import { t } from "../../hooks/useAppTranslation";
import moment from "moment";

export const AuditDetail = props => {
	const {auditData: data} = props;
	
	if (data) {
		return <>
			<div className='row' style={{marginTop: '1rem'}}>
				<div className='col'><b>{t('g-creation-date')}</b></div>
				<div className='col'><b>{t('g-who-created')}</b></div>
			</div>
			<div className='row'>
				<div className='col'>{data?.createdOn ? moment.utc(data?.createdOn).local().format('YYYY-MM-DD k:mm:ss').toString() : '-'}</div>
				<div className='col'>{data?.createdByLogin ? data?.createdByLogin : data?.createdBy ? data?.createdBy : '-' }</div>
			</div>
			<div className='row' style={{marginTop: '1rem'}}>
				<div className='col'><b>{t('g-last-modification-date')}</b></div>
				<div className='col'><b>{t('g-who-modified')}</b></div>
			</div>
			<div className='row'>
				<div className='col'>{data?.updatedOn ? moment.utc(data?.updatedOn).local().format('YYYY-MM-DD k:mm:ss').toString() : '-'}</div>
				<div className='col'>{data?.updatedByLogin ? data?.updatedByLogin : data?.updatedBy ? data?.updatedBy : '-'}</div>
			</div>
		</>
	}
	return null;
};
